export default __webpack_public_path__ + "static/media/arg_exp_logo.81eb1273.webp";